var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover",on:{"click":_vm.clickToStart}},[_c('img',{staticClass:"waiting",attrs:{"src":require("@/assets/loading.gif")}}),(_vm.isBrowserGame)?_c('h1',[_vm._v("click to start")]):_c('h1',[_vm._v(_vm._s(_vm.tip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }